import NetworkService from "./NetworkService";
import ConfigService from "./ConfigService";

const AuthService = (() => {
  let instance;

  function createInstance() {
    return new AuthServiceInstance();
  }

  return {
    getInstance: function (config) {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
})();

export default AuthService;

class AuthServiceInstance {
  networkService = NetworkService;
  loginUrl = "";
  logoutUrl = "";
  revokeTokenUrl = "";
  redirectUri = "";
  userInfoUrl = "";
  scope = "";
  context = "/";
  _storage = localStorage;
  rngUrl = "";
  oauthState = {};
  clearHashAfterLogin = true;
  principal = {};
  verifyAppleIdCodeUrl = "";

  configService = ConfigService.getInstance();

  // The OAuth client id/secret used to be copied here too. The browser never
  // needs them (the only consumer was a commented-out Basic auth header), so
  // they're no longer read; the secret shouldn't be served to the client at
  // all — see config.json on the server side.
  updateConfig = (config) => {
    if (config) {
      this.userInfoUrl = config.userInfoUrl;
    }
  };

  getPrincipal = async (principal = {}) => {
    this.principal = principal;
    return this.principal;
    //return this._storage.getItem("principal") ? JSON.parse(this._storage.getItem("principal")) : {};
  };

  retrieveUserInfoFromServer = () => {
      return this.networkService
        .get(this.configService.formulateContextPath(this.userInfoUrl))
        .then((res) => {
          return Promise.resolve(this.getPrincipal(res));
        })
        .catch((e) => {
          return Promise.reject(e);
        });
  };

  resetPassword = (email, csrf) => {
    const headers = {};
    //const token = window.btoa(this.clientId + ":" + this.clientSecret);
    //headers.Authorization = `Basic ${token}`;
    headers[csrf?.headerName || "X-XSRF-TOKEN"] = csrf?.token;
    const url = `${this.configService.formulateContextPath('/proxy/basic/reset-password')}`;
    return this.networkService.post(url, { username: email }, headers);
  };

}
